
const data = [
    {
        id: 1,
        job: "Protocol Engineers",
    },
    {
        id: 2,
        job: "Systems Engineers", 
    },
    {
        id: 3,
        job: " Head of Marketing",
    },
    {
        id: 4,
        job: "Rust Engineers",
    },
    {
        id: 5,
        job: " Cryptographers",
    },
    {
        id: 6,
        job: "Head of BD/Sales",
    },
    {
        id: 7,
        job: "Golang Engineers",
    },
    {
        id: 8,
        job: "Product Managers ",
    },
    {
        id: 9,
        job: "ML Engineers",
    },
    {
        id: 10,
        job: "Community Managers",
    },
    {
        id: 11,
        job: "Product Designers  ",
    },
    {
        id: 12,
        job: "C-level, Advisors",
    },
    {
        id: 13,
        job: "UI/UX Engineers",
    },
    {
        id: 14,
        job: "Finance and Operations",
    },
    //eslint-disable-next-line
]
export default data;